export function blockVideo() {
    document.querySelectorAll('.video-block').forEach((container) => {
        const video = container.querySelector("video"),
            playPause = container.querySelector(".play-pause"),
            currentTime = container.querySelector(".current-time"),
            duration = container.querySelector(".duration"),
            buffer = container.querySelector(".buffer"),
            totalDuration = container.querySelector(".total-duration"),
            currentDuration = container.querySelector(".current-duration"),
            controls = container.querySelector(".controls"),
            videoContainer = container.querySelector(".video-container"),
            muteUnmute = container.querySelector(".mute-unmute"),
            hoverTime = container.querySelector(".hover-time"),
            hoverDuration = document.querySelector(".hover-duration");

        set_control_state(video);

        window.addEventListener('resize', function (){
            set_control_state(video);
        })

        let isPlaying = false,
            mouseDownProgress = false,
            mouseDownVol = false,
            isCursorOnControls = false,
            muted = false,
            timeout,
            volumeVal = 1,
            mouseOverDuration = false,
            touchClientX = 0,
            touchPastDurationWidth = 0,
            touchStartTime = 0;

        // Video Event Listeners
        video.addEventListener("loadedmetadata", canPlayInit);
        video.addEventListener("play", play);
        video.addEventListener("pause", pause);
        video.addEventListener("progress", handleProgress);

        document.addEventListener("keydown", handleShorthand);

        playPause.addEventListener("click", (e) => {
            if (!isPlaying) {
                play();
            } else {
                pause();
            }
        });

        duration.addEventListener("click", navigate);

        duration.addEventListener("mousedown", (e) => {
            mouseDownProgress = true;
            navigate(e);
        });

        document.addEventListener("mouseup", (e) => {
            mouseDownProgress = false;
            mouseDownVol = false;
        });

        document.addEventListener("mousemove", handleMousemove);

        duration.addEventListener("mouseenter", (e) => {
            mouseOverDuration = true;
        });
        duration.addEventListener("mouseleave", (e) => {
            mouseOverDuration = false;
            hoverTime.style.width = 0;
            hoverDuration.innerHTML = "";
        });


        videoContainer.addEventListener("mouseleave", hideControls);
        videoContainer.addEventListener("mousemove", (e) => {
            controls.classList.add("show-controls");
            hideControls();
        });
        videoContainer.addEventListener("touchstart", (e) => {
            controls.classList.add("show-controls");
            touchClientX = e.changedTouches[0].clientX;
            const currentTimeRect = currentTime.getBoundingClientRect();
            touchPastDurationWidth = currentTimeRect.width;
            touchStartTime = e.timeStamp;
        });
        videoContainer.addEventListener("touchend", () => {
            hideControls();
            touchClientX = 0;
            touchPastDurationWidth = 0;
            touchStartTime = 0;
        });
        videoContainer.addEventListener("touchmove", handleTouchNavigate);

        controls.addEventListener("mouseenter", (e) => {
            controls.classList.add("show-controls");
            isCursorOnControls = true;
        });

        controls.addEventListener("mouseleave", (e) => {
            isCursorOnControls = false;
        });

        muteUnmute.addEventListener("click", toggleMuteUnmute);

        function canPlayInit() {
            totalDuration.innerHTML = showDuration(video.duration);
            video.volume = volumeVal;
            muted = video.muted;
            if (video.paused) {
                controls.classList.add("show-controls");

            }
        }

        function play() {
            video.play();
            isPlaying = true;
            playPause.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" class="fill-neutral-2"><!--! Font Awesome Pro 6.4.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path d="M48 64C21.5 64 0 85.5 0 112V400c0 26.5 21.5 48 48 48H80c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48H48zm192 0c-26.5 0-48 21.5-48 48V400c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48H240z"/></svg>
                   <span class="sr-only">Pause</span>`;

        }

        video.ontimeupdate = handleProgressBar;

        function handleProgressBar() {
            currentTime.style.width = (video.currentTime / video.duration) * 100 + "%";
            currentDuration.innerHTML = showDuration(video.currentTime);
        }

        function pause() {
            video.pause();
            isPlaying = false;
            playPause.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" class="fill-neutral-2"><!--! Font Awesome Pro 6.4.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path d="M73 39c-14.8-9.1-33.4-9.4-48.5-.9S0 62.6 0 80V432c0 17.4 9.4 33.4 24.5 41.9s33.7 8.1 48.5-.9L361 297c14.3-8.7 23-24.2 23-41s-8.7-32.2-23-41L73 39z"/></svg>
                            <span class="sr-only">Play</span>`;
            controls.classList.add("show-controls");
            if (video.ended) {
                currentTime.style.width = 100 + "%";
            }
        }

        function navigate(e) {
            const totalDurationRect = duration.getBoundingClientRect();
            const width = Math.min(
                Math.max(0, e.clientX - totalDurationRect.x),
                totalDurationRect.width
            );
            currentTime.style.width = (width / totalDurationRect.width) * 100 + "%";
            video.currentTime = (width / totalDurationRect.width) * video.duration;
        }

        function handleTouchNavigate(e) {
            hideControls();
            if (e.timeStamp - touchStartTime > 500) {
                const durationRect = duration.getBoundingClientRect();
                const clientX = e.changedTouches[0].clientX;
                const value = Math.min(
                    Math.max(0, touchPastDurationWidth + (clientX - touchClientX) * 0.2),
                    durationRect.width
                );
                currentTime.style.width = value + "px";
                video.currentTime = (value / durationRect.width) * video.duration;
                currentDuration.innerHTML = showDuration(video.currentTime);
            }
        }

        function showDuration(time) {
            const hours = Math.floor(time / 60 ** 2);
            const min = Math.floor((time / 60) % 60);
            const sec = Math.floor(time % 60);
            if (hours > 0) {
                return `${formatter(hours)}:${formatter(min)}:${formatter(sec)}`;
            } else {
                return `${formatter(min)}:${formatter(sec)}`;
            }
        }

        function formatter(number) {
            return new Intl.NumberFormat({}, {minimumIntegerDigits: 2}).format(number);
        }

        function toggleMuteUnmute() {
            if (!muted) {
                video.volume = 0;
                muted = true;
                muteUnmute.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" class="fill-neutral-2"><!--! Font Awesome Pro 6.4.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path d="M301.1 34.8C312.6 40 320 51.4 320 64V448c0 12.6-7.4 24-18.9 29.2s-25 3.1-34.4-5.3L131.8 352H64c-35.3 0-64-28.7-64-64V224c0-35.3 28.7-64 64-64h67.8L266.7 40.1c9.4-8.4 22.9-10.4 34.4-5.3zM425 167l55 55 55-55c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-55 55 55 55c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-55-55-55 55c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l55-55-55-55c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0z"/></svg>
                              <span class="sr-only">Sound Off</span>`;
            } else {
                video.volume = volumeVal;
                muted = false;
                muteUnmute.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" class="fill-neutral-2"><!--! Font Awesome Pro 6.4.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path d="M333.1 34.8C344.6 40 352 51.4 352 64V448c0 12.6-7.4 24-18.9 29.2s-25 3.1-34.4-5.3L163.8 352H96c-35.3 0-64-28.7-64-64V224c0-35.3 28.7-64 64-64h67.8L298.7 40.1c9.4-8.4 22.9-10.4 34.4-5.3zm172 72.2c43.2 35.2 70.9 88.9 70.9 149s-27.7 113.8-70.9 149c-10.3 8.4-25.4 6.8-33.8-3.5s-6.8-25.4 3.5-33.8C507.3 341.3 528 301.1 528 256s-20.7-85.3-53.2-111.8c-10.3-8.4-11.8-23.5-3.5-33.8s23.5-11.8 33.8-3.5zm-60.5 74.5C466.1 199.1 480 225.9 480 256s-13.9 56.9-35.4 74.5c-10.3 8.4-25.4 6.8-33.8-3.5s-6.8-25.4 3.5-33.8C425.1 284.4 432 271 432 256s-6.9-28.4-17.7-37.3c-10.3-8.4-11.8-23.5-3.5-33.8s23.5-11.8 33.8-3.5z"/></svg>
                              <span class="sr-only">Sound On</span>`;
            }
        }

        function hideControls() {
            if (timeout) {
                clearTimeout(timeout);
            }
            timeout = setTimeout(() => {
                if (isPlaying && !isCursorOnControls) {
                    controls.classList.remove("show-controls");
                }
            }, 1000);
        }

        function handleProgress() {
            if (!video.buffered || !video.buffered.length) {
                return;
            }
            const width = (video.buffered.end(0) / video.duration) * 100 + "%";
            buffer.style.width = width;
        }

        function handleMousemove(e) {
            if (mouseDownProgress) {
                e.preventDefault();
                navigate(e);
            }

            if (mouseOverDuration) {
                const rect = duration.getBoundingClientRect();
                const width = Math.min(Math.max(0, e.clientX - rect.x), rect.width);
                const percent = (width / rect.width) * 100;
                hoverTime.style.width = width + "px";
                hoverDuration.innerHTML = showDuration((video.duration / 100) * percent);
            }
        }

        function handleShorthand(e) {
            const tagName = document.activeElement.tagName.toLowerCase();
            if (tagName === "input") return;
            if (e.key.match(/[0-9]/gi)) {
                video.currentTime = (video.duration / 100) * (parseInt(e.key) * 10);
                currentTime.style.width = parseInt(e.key) * 10 + "%";
            }
            switch (e.key.toLowerCase()) {
                case " ":
                    if (tagName === "button") return;
                    if (isPlaying) {
                        video.pause();
                    } else {
                        video.play();
                    }
                    break;
                case "m":
                    toggleMuteUnmute();
                    break;

                default:
                    break;
            }
        }
    })
}

function set_control_state(elem) {
    let resolution = window.matchMedia("(min-width: 1024px) ");

    if(resolution.matches){
        elem.removeAttribute('controls')
    }else{
        elem.setAttribute('controls', true)
    }
}